export const reconciliationOptions = {
  BOOKING_COMPLETED: 'completedAt',
  STUDENT_CHECK_IN: 'finalMoveInDate',
  STUDENT_CHECK_OUT: 'finalMoveOut',
};

export const orderInstalmentPlanType = {
  FULL_PAYMENT: 'FULL_PAYMENT',
  PAY_QUARTERLY: 'PAY_QUARTERLY',
  PAY_MONTHLY: 'PAY_MONTHLY',
  PAY_WEEKLY: 'PAY_WEEKLY',
  PAY_REMAINDER_AT_ONCE: 'PAY_REMAINDER_AT_ONCE',
};

export const orderCounterOfferDiscountType = {
  PERCENTAGE: 'PERCENTAGE',
  ABSOLUTE: 'ABSOLUTE',
};

export const sortDirection = { descend: 'DESCENDING', ascend: 'ASCENDING' };

export const sortFields = {
  moveInDate: 'MOVE_IN_DATE',
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT',
};
